import React from 'react';
import { Container, Card } from 'react-bootstrap';

function Contact() {
  return (
    <Container className="py-4 d-flex justify-content-center">
      <Card className="shadow" style={{ width: '100%', maxWidth: '500px' }}>
        <Card.Body>
          <h2 className="mb-3">Contact Us</h2>
          <p>
            If you need support, please email us at{' '}
            <a href="mailto:support@sondehealth.com">support@sondehealth.com</a>.
          </p>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default Contact;